import DeliveryAddress from "../components/DeliveryAddress/DeliveryAddress";

const CheckoutPage = () => {
  return <DeliveryAddress />;
};

export default CheckoutPage;
